/**
 * Sistema de Leads Modular - Constantes
 * 
 * Configurações padrão reutilizáveis
 */

import { StatusConfigMap, LeadStatus } from './types';

export const DEFAULT_STORAGE_KEY = 'leads_sistema';

export const DEFAULT_STATUS_CONFIG: StatusConfigMap = {
  novo: { 
    label: 'Novo', 
    color: 'text-blue-700', 
    bg: 'bg-blue-50 border-blue-200', 
    icon: 'ri-star-line' 
  },
  'em-analise': { 
    label: 'Em Análise', 
    color: 'text-yellow-700', 
    bg: 'bg-yellow-50 border-yellow-200', 
    icon: 'ri-search-eye-line' 
  },
  'em-negociacao': { 
    label: 'Em Negociação', 
    color: 'text-orange-700', 
    bg: 'bg-orange-50 border-orange-200', 
    icon: 'ri-discuss-line' 
  },
  convertido: { 
    label: 'Convertido', 
    color: 'text-green-700', 
    bg: 'bg-green-50 border-green-200', 
    icon: 'ri-checkbox-circle-line' 
  },
  perdido: { 
    label: 'Perdido', 
    color: 'text-red-700', 
    bg: 'bg-red-50 border-red-200', 
    icon: 'ri-close-circle-line' 
  },
};

export const TODOS_CONFIG = {
  label: 'Todos',
  color: 'text-gray-700',
  bg: 'bg-gray-50 border-gray-200',
  icon: 'ri-list-check'
};

// Lista de status para uso em dropdowns e validações
export const LEAD_STATUSES = [
  { value: 'novo' as LeadStatus, label: 'Novo', color: 'blue' },
  { value: 'em-analise' as LeadStatus, label: 'Em Análise', color: 'yellow' },
  { value: 'em-negociacao' as LeadStatus, label: 'Em Negociação', color: 'orange' },
  { value: 'convertido' as LeadStatus, label: 'Convertido', color: 'green' },
  { value: 'perdido' as LeadStatus, label: 'Perdido', color: 'red' },
];

export const CSV_HEADERS = [
  'Nome',
  'Telefone',
  'Email',
  'Serviço de Interesse',
  'Página de Origem',
  'Data/Hora',
  'Origem',
  'Botão Clicado',
  'Responsável',
  'Status',
  'Observações',
  'UTM Source',
  'UTM Medium',
  'UTM Campaign',
];

// Opções padrão para formulários
export const DEFAULT_ORIGIN_OPTIONS = [
  'WhatsApp',
  'Formulário',
  'Comunidade',
  'Análise Gratuita',
  'Telefone',
  'Email',
  'Indicação',
  'Outro'
] as const;

export const DEFAULT_SERVICE_OPTIONS = [
  'Automóvel',
  'Vida Empresarial',
  'Incêndio Empresarial',
  'Gestão de Contratos',
  'Consultoria Técnica',
  'Recuperação de Sinistros',
  'Suporte e Acompanhamento'
] as const;